import { useState, useEffect, useCallback } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { getVisibleCharacters, type DbCharacter } from '@/api/astraea';

export default function MaterialsIndexPage() {
  const nav = useNavigate();
  const [chars, setChars] = useState<DbCharacter[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    getVisibleCharacters()
      .then(setChars)
      .finally(() => setLoading(false));
  }, []);

  return (
    <div className="max-w-3xl mx-auto px-4 py-8 md:py-12">
      <Link to="/" className="text-xs text-secondary-500 hover:text-primary-600"><i className="ri-arrow-left-line mr-1"></i>返回首页</Link>
      <h1 className="text-2xl font-bold text-foreground-950 mt-3">角色素材库</h1>
      <p className="text-sm text-foreground-600 mt-2 leading-relaxed">
        固定角色长相、身材、声音与生活风格，生成可直接用于朋友圈、短视频、私信破冰与深度引流的素材。
      </p>

      {loading ? (
        <div className="py-16 text-center text-sm text-secondary-400">读取中…</div>
      ) : chars.length === 0 ? (
        <div className="mt-8 rounded-2xl border border-dashed border-secondary-300 p-8 text-center">
          <p className="text-sm text-foreground-600">还没有角色，先建一个就能开始出素材。</p>
          <Link to="/create" className="inline-flex mt-4 px-4 py-2 rounded-lg bg-primary-500 text-white text-sm font-semibold">一键新建角色</Link>
        </div>
      ) : (
        <div className="mt-6 space-y-2">
          {chars.map((c) => (
            <button
              key={c.id}
              type="button"
              onClick={() => nav(`/materials/${c.id}`)}
              className="w-full flex items-center gap-3 p-4 rounded-xl border border-secondary-200 bg-background-50 hover:border-primary-300 cursor-pointer text-left"
            >
              <div className="w-12 h-12 rounded-full overflow-hidden bg-primary-100 flex-shrink-0">
                {c.avatar_url ? <img src={c.avatar_url} alt="" className="w-full h-full object-cover" /> : <i className="ri-user-smile-line text-2xl text-primary-500 flex items-center justify-center h-full"></i>}
              </div>
              <div className="flex-1 min-w-0">
                <div className="font-semibold text-foreground-950">{c.name}</div>
                <div className="text-xs text-secondary-500 truncate">{c.description || '进入素材库'}</div>
              </div>
              <i className="ri-arrow-right-s-line text-secondary-400 text-xl"></i>
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
